import { render, staticRenderFns } from "./SupportCenter.vue?vue&type=template&id=3324fd48"
import script from "./SupportCenter.vue?vue&type=script&lang=js"
export * from "./SupportCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports